import React, {Component} from 'react';
import _ from 'lodash';
import moment from 'moment';
import IoAndroidSend from 'react-icons/lib/io/android-send';
import FaCircle from 'react-icons/lib/fa/circle';
import SoundNotification from "../NotificationSound";
import MdArrowDownward from "react-icons/lib/md/arrow-downward";
import ReactTooltip from "react-tooltip";
import IconSpinner from "react-icons/lib/fa/spinner";
import {validateUrl} from "../../utils/validator";

 class ChatDentist extends Component {
    constructor(props){
        super(props);
        this.state = {
            showDentistList: true
        }
    }
    dentistChat={
        zIndex: '9',
        width: '320px',
        height: '374px',
        borderRadius: '10px 10px 0 0',
        position: 'fixed',
        bottom: '38px',
        right: '40px',
    }
    componentDidUpdate(prevProps) {
        if (this.messagesEnd && (!this.props.isMinimized && prevProps.isMinimized)
            || (this.props.adminIsOnline && !prevProps.adminIsOnline)
            || (this.props.addedMessage && !prevProps.addedMessage) || (!_.isEqual(this.props.messages, prevProps.messages) && this.props.isScrolledToBottom)) {
            this.props.scrollToBottom(this.messagesEnd);
        }
    }

    openMessageBlock = (id) => {
        this.setState({
            showDentistList: false
        })
    }
    openDentistsList = () => {
        this.setState({
            showDentistList: true
        })
    }
    renderMinimizedChat = () => {
        const {
            numberOfMessages,
        } = this.props;
        
        return <div className="chat__minimized" onClick={this.props.toggleMinimizedState}>
            <button className="btn btn-chat">
                <span className="kr kr-chat" />
                {numberOfMessages ?
                    <span className="message-notification-user badge badge-danger">{numberOfMessages}</span>
                    : null
                }
            </button>
        </div>;
    };

    renderLoader = () => {
        return <h1 className="text-center chat__loader"><IconSpinner size={20} className="spinner"/></h1>;
    };

    renderLoadMessages = () => {
        const {noMoreMessages} = this.props;
        return <button className="btn-link btn-link-black load__more-btn"
                       onClick={this.props.handleLoadMore}>{noMoreMessages ? 'No More Messages' : 'Load More'}</button>;
    };

    renderMessages = () => {
        const {
            currentUser,
            messages,
        } = this.props;
        return messages.sort((a, b) => (new Date(a.created_at) - new Date(b.created_at))).map(message => (
            <div key={message.id} className="message-box-holder" ref={(el) => {
                this.messagesEnd = el;
            }}>
                <div
                    className={`message-box ${currentUser.id === message.from ? '' : 'chat__messages-received'}
                                     `}  dangerouslySetInnerHTML={{__html: validateUrl(message.message, 'btn-link-black')}}>
                </div>
                <div
                    className={`${currentUser.id === message.from ? 'message-sender' : 'message-sender-sent'}`}>
                    {moment(message.created_at).calendar(null, {
                        sameDay: 'HH:mm',
                        nextDay: '[Tomorrow] HH:mm',
                        nextWeek: 'ddd',
                        lastDay: '[Yesterday] HH:mm',
                        lastWeek: 'ddd HH:mm',
                        sameElse: 'DD MMM HH:mm'
                    })}
                </div>
            </div>
        ))
    };

    renderMaximizedChat = () => {
        const {
            selectedUser,
            messages,
            message,
            loadingMessages,
            isScrolledToBottom,
            adminIsOnline
        } = this.props;
        return <div className="chat__maximized-body">
            {adminIsOnline ? null : <div className="chat__maximized__offline">
                We're currently offline. Please submit your message and we will get back to you shortly.
            </div>}
            <div className={`chat__maximized__messages ${adminIsOnline ? '' : 'chat__maximized__messages-offline'}`} onScroll={() => this.props.handleScroll(this.messagesEnd)} >
                {loadingMessages ?
                    this.renderLoader() : this.renderLoadMessages()
                }

                {messages && selectedUser ? this.renderMessages() : null}
                {!isScrolledToBottom ? <button
                    data-tip="Go to bottom"
                    onClick={() => this.props.scrollToBottom(this.messagesEnd)} className="btn btn-fab btn-sm button__arrow__down button__arrow__down-user">
                    <MdArrowDownward size={20}/>
                </button> : null}
                <ReactTooltip place="top" type="light" effect="float"/>
            </div>
            <div className="chat__maximized__actions-box">
                <button
                    className="chat__maximized__actions-send btn-link btn-link-black"
                    onClick={this.props.addNewMessage}
                >
                    <span className="kr kr-send" />
                </button>
                <textarea
                    onKeyPress={this.props.handleKeyPress}
                    onChange={this.props.handleMessageChange}
                    className="message-input"
                    name="message"
                    value={message}
                    placeholder="Type your message"
                />
            </div>
        </div>
    }

    renderMaximizedChatIfAdminIsOnline = () => {
        return <div className="chat__maximized" style={this.dentistChat}>
            <div className="chat__maximized-title">
                <div className="chat__maximized-partner">
                <FaCircle 
                        className="chat__maximized-partner__status"
                color="#00ff00"/> 
                       Lab Admin
                </div>
                <div className="chat__maximized-icons">
                        <span
                            className="kr kr-close"
                            onClick={this.props.toggleMinimizedState}
                        />
                </div>
            </div>
            {this.renderMaximizedChat()}
        </div>
    };

    renderMaximizedChatIfAdminIsOffline = () => {
        return <div className="chat__maximized" style={this.dentistChat}>
            <div className="chat__maximized-title">
                <div className="chat__maximized-partner">
                    <FaCircle className="chat__maximized-partner__status"
                              color="#888888"/>
                              Lab Admin
                </div>
                <div className="chat__maximized-icons">
                        <span
                            className="kr kr-close"
                            onClick={this.props.toggleMinimizedState}
                        />
                </div>
            </div>
            {this.renderMaximizedChat()}
        </div>
    };

    render() {
        const {
            isMinimized,
            adminIsOnline,
            hasNotification,
        } = this.props;
        return <div id="chat-widget">
            {this.renderMinimizedChat()}
            {isMinimized ? this.renderMinimizedChat()
                :
                adminIsOnline ? this.renderMaximizedChatIfAdminIsOnline() : this.renderMaximizedChatIfAdminIsOffline()}
            <SoundNotification resetHasNotification={this.props.resetHasNotification}
                               hasNotification={hasNotification}/>
        </div>
    }
}
export default ChatDentist;


// WEBPACK FOOTER //
// ./src/components/Chat/dentist.js